export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS';